import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight, ShieldCheck } from "lucide-react";
import api, { imageUrl } from "../lib/api";
import Seo from "../components/Seo";

const Projects = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/projects").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12">
      <Seo title="Our Projects — Townships & Residential Projects in Jaipur | Satyam Real Estate"
        description="Explore residential townships, plotted developments and luxury villa projects Satyam Real Estate is working on across Jaipur." />
      <nav className="text-sm text-stone-500 mb-4">
        <Link to="/" className="hover:text-brand">Home</Link> <span className="mx-1.5">/</span>
        <span className="text-stone-800">Projects</span>
      </nav>
      <h1 className="font-heading text-4xl sm:text-5xl text-stone-900">Our Projects</h1>
      <p className="text-stone-500 mt-3 max-w-2xl">Handpicked townships and residential projects we are working on across Jaipur.</p>

      {loading ? (
        <div className="grid gap-8 md:grid-cols-2 mt-10">
          {[...Array(2)].map((_, i) => <div key={i} className="h-[420px] rounded-3xl bg-stone-100 animate-pulse" />)}
        </div>
      ) : items.length === 0 ? (
        <div className="text-center py-24 border border-dashed border-stone-300 rounded-2xl mt-10">
          <p className="font-heading text-xl text-stone-800">No projects yet</p>
        </div>
      ) : (
        <div className="grid gap-8 md:grid-cols-2 mt-10" data-testid="projects-grid">
          {items.map((p) => (
            <Link key={p._id} to={`/projects/${p.slug}`} data-testid={`project-card-${p.slug}`}
              className="group bg-white rounded-3xl overflow-hidden border border-stone-200 hover-lift">
              <div className="relative aspect-[16/10] overflow-hidden bg-stone-100">
                {p.hero_image && <img src={imageUrl(p.hero_image)} alt={p.title} className="w-full h-full object-cover img-zoom" />}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute top-4 left-4 flex gap-2">
                  <span className="rounded-full bg-brand text-white text-[11px] font-semibold px-3 py-1">{p.status}</span>
                  {p.rera_id && <span className="rounded-full bg-white/90 text-stone-800 text-[11px] font-semibold px-3 py-1 flex items-center gap-1"><ShieldCheck size={12} /> RERA</span>}
                </div>
                <div className="absolute bottom-0 p-6">
                  <h2 className="font-heading text-3xl text-white">{p.title}</h2>
                  <p className="flex items-center gap-1.5 text-white/85 text-sm mt-1"><MapPin size={14} /> {p.location}</p>
                </div>
              </div>
              <div className="p-6">
                <p className="text-sm text-stone-600 line-clamp-2">{p.tagline}</p>
                {p.highlights?.length > 0 && (
                  <div className="flex flex-wrap gap-2 mt-4">
                    {p.highlights.slice(0, 3).map((h) => (
                      <span key={h} className="rounded-full bg-accent text-brand text-[11px] font-medium px-2.5 py-1">{h}</span>
                    ))}
                  </div>
                )}
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand mt-5 group-hover:gap-2.5 transition-all">
                  View Project <ArrowRight size={15} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Projects;
